import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO } from '../config';
import './Footer.css';

function Footer({ config }) {
  const currentYear = new Date().getFullYear();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>{config.name}</h3>
          <p>{config.tagline}</p>
        </div>
        <div className="footer-section">
          <h4>Contact Us</h4>
          <ul>
            <li>Phone: {CONTACT_INFO.phone}</li>
            <li>Email: {displayEmail}</li>
            <li>{CONTACT_INFO.address}</li>
            <li>{CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/search">Search</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Information</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} {config.name}. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
